/* -*- Mode: js; tab-width: 2; indent-tabs-mode: nil; js-indent-level: 2 -*- */

/* Copyright (C) Itseez3D, Inc. - All Rights Reserved
 * You may not use this file except in compliance with an authorized
 * license Unauthorized copying of this file, via any medium is
 * strictly prohibited Proprietary and confidential
 * UNLESS REQUIRED BY APPLICABLE LAW OR AGREED BY ITSEEZ3D, INC. IN
 * WRITING, SOFTWARE DISTRIBUTED UNDER THE LICENSE IS DISTRIBUTED ON
 * AN "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * EITHER EXPRESS OR IMPLIED
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * Written by Itseez3D, Inc. <support@itseez3D.com>, October 2018
 */

import * as THREE from 'three';
import JSZip from 'jszip';
import { PLYLoader } from './PLYLoader';

export function AvatarSDKFileLoader(bearer, playerUID) {
  this.bearer = bearer;
  this.playerUID = playerUID;
}

Object.assign(AvatarSDKFileLoader.prototype, {
  load: function(url, onLoad, onProgress, onError) {
    if (!this.bearer) {
      if (!!onError) {
        return onError('empty bearer');
      }
      return;
    }

    var xhr = new XMLHttpRequest();
    var auth = 'Bearer ' + this.bearer;

    xhr.addEventListener('load', function(ev){
      var status = ev.target.status;

      if (status >= 200 && status < 300) {
        if (!!onLoad) {
          onLoad(ev.target.response, ev);
        }
      } else {
        if (!!onError) {
          onError(ev.target.response, ev);
        }
      }
    });

    xhr.addEventListener('progress', onProgress);

    xhr.open('GET', url);
    xhr.responseType = 'arraybuffer';
    xhr.setRequestHeader('Authorization', auth);

    if (!!this.playerUID) {
      xhr.setRequestHeader('X-PlayerUID', this.playerUID);
    }

    xhr.send(null);
  }
});

// =============================================================================

export function AvatarSDKTextureLoader(fileLoader) {
  this.fileLoader = fileLoader;
}

Object.assign(AvatarSDKTextureLoader.prototype, {
  load: function(url, onLoad, onProgress, onError) {
    this.fileLoader.load(url, onTextureLoaded, onProgress, onError);

    function onTextureLoaded(data, event) {
      var arrayBufferView = new Uint8Array(data);
      var mimeType = event.target.getResponseHeader('content-type') || mime;
      var blob = new Blob([arrayBufferView], {type: mimeType});
      var imageUrl = URL.createObjectURL(blob);

      var img = new Image();
      img.onload = function onImgLoad() {
        console.log('image size', img.width, img.height);

        URL.revokeObjectURL(imageUrl);

        var texture = new THREE.Texture();
        texture.image = img;
        texture.format = THREE.RGBFormat;
        texture.needsUpdate = true;

        if (!!onLoad) {
          onLoad(texture);
        }
      }

      img.src = imageUrl;
    }
  }
})

// =============================================================================

export function AvatarSDKGeometryLoader(fileLoader) {
  this.fileLoader = fileLoader;
}

Object.assign(AvatarSDKGeometryLoader.prototype, {
  load: function(url, filename, onLoad, onProgress, onError) {
    this.fileLoader.load(url, onMeshLoaded, onProgress, onError);

    function onMeshLoaded(ply, event) {
      var status = event.target.status;
      if (status == 204) {
        if (!!onLoad) {
          return onLoad(null);
        }
        return;
      }

      console.time('unzip');
      var zip = new JSZip();
      zip.loadAsync(ply).then((content) => {
        var files = Object.keys(content.files);
        console.log('files:', files);

        if (files.length <= 0) {
          console.error('empty zip');
          if (!!onError) {
            return onError('empty zip');
          }
          return;
        }

        console.timeEnd('unzip');
        zip.file(filename)?.async('arraybuffer').then((buff) => {
          console.log(buff);
          var geometry = null;
          const plyLoader = new PLYLoader(THREE.DefaultLoadingManager);
          geometry = plyLoader.parse(buff);
          console.log(geometry);

          if (!!onLoad) {
            console.log("onload");
            
            return onLoad(geometry);
          }
        });
      });
    }
  }
})
